// Guards
import guards from './guards'
// GeneralViews
import NotFound from 'src/views/Pages/GeneralViews/NotFoundPage.vue'
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue'
// Layouts
import DashboardLayout from 'src/views/Layouts/DashboardLayout.vue'
// Auth
import Login from 'src/views/Pages/Auth/Login.vue'
import PasswordReset from 'src/views/Pages/Auth/PasswordReset.vue'
import Lock from 'src/views/Pages/Auth/Lock.vue'
// Dashboard pages
import Home from 'src/views/Pages/Dashboard/Home/Home.vue'
import User from 'src/views/Pages/Dashboard/User/UserProfile.vue'
// -------------------------------------------------------------------------------
// -------------------------- Configuraciones Nivel 2 ----------------------------
// -------------------------------------------------------------------------------
// Pages Maestros - Module
import Modules from 'src/views/Pages/Dashboard/Modules/Modules.vue'
import ModuleCreateEdit from 'src/views/Pages/Dashboard/Modules/ModuleCreateEdit.vue'
// Pages Maestros - Company
import Companies from 'src/views/Pages/Dashboard/Companies/Companies.vue'
import CompaniesCreateEdit from 'src/views/Pages/Dashboard/Companies/CompaniesCreateEdit.vue'
// Pages Maestros - Department
import Departments from 'src/views/Pages/Dashboard/Departments/Departments.vue'
// Pages Maestros - Role
import Roles from 'src/views/Pages/Dashboard/Roles/Roles.vue'
// Pages Maestros - Permission
import Permissions from 'src/views/Pages/Dashboard/Permissions/Permissions.vue'
// Pages Maestros - User
import Users from 'src/views/Pages/Dashboard/Users/Users.vue'
import UserCreateEdit from 'src/views/Pages/Dashboard/Users/UserCreateEdit.vue'
// Pages Maestros - Company
import Monitorings from 'src/views/Pages/Dashboard/Monitorings/Monitorings.vue'
import MonitoringsCreateEdit from 'src/views/Pages/Dashboard/Monitorings/MonitoringsCreateEdit.vue'
// Pages Maestros - Demands
import Demands from 'src/views/Pages/Dashboard/Demands/Demands.vue'
import DemandsCreateEdit from 'src/views/Pages/Dashboard/Demands/DemandsCreateEdit.vue'
// Pages Maestros - Planning
import Plannings from 'src/views/Pages/Dashboard/Plannings/Plannings.vue'
import PlanningCreateEdit from 'src/views/Pages/Dashboard/Plannings/PlanningCreateEdit.vue'
// Pages Informe - INstalations
import Instalations from 'src/views/Pages/Dashboard/Instalations/Instalations.vue'
// Pages Informe - Subscriptions
import Subscriptions from 'src/views/Pages/Dashboard/Subscriptions/Subscriptions.vue'
// Pages Informe - Inventories
import Inventories from 'src/views/Pages/Dashboard/Inventories/Inventories.vue'
// Pages Informe - OperationsUsers
import OperationsUsers from 'src/views/Pages/Dashboard/OperationsUsers/operationsUsers.vue'
// Pages Informe - OperationsUsers
import BillingSupports from 'src/views/Pages/Dashboard/BillingSupports/billingSupports.vue'
// Pages Informe - PQRSMaintenance
import PqrsMaintenance from 'src/views/Pages/Dashboard/PqrsMaintenance/pqrsMaintenance.vue'
// Pages Informe - PreventiveMaintenance
import PreventiveMaintenance from 'src/views/Pages/Dashboard/PreventiveMaintenance/preventiveMaintenance.vue'
// Pages Informe - Indicators
import Indicators from 'src/views/Pages/Dashboard/Indicators/Indicators.vue'
// Pages Informe - ChangesReplacements
import ChangesReplacements from 'src/views/Pages/Dashboard/ChangesReplacements/ChangesReplacements.vue'
// Pages Informe - QualityUserSupports
import QualityUserSupports from 'src/views/Pages/Dashboard/QualityUserSupports/QualityUserSupports.vue'
// Pages Informe - TelephoneAttentionChannel
import TelephoneAttentionChannel from 'src/views/Pages/Dashboard/TelephoneAttentionChannel/TelephoneAttentionChannel.vue'
// Pages Informe - Availability
import Availability from 'src/views/Pages/Dashboard/Availability/Availability.vue'
// Pages Informe - NavigationSpeed
import NavigationSpeed from 'src/views/Pages/Dashboard/NavigationSpeed/NavigationSpeed.vue'
// Pages Informe - DeviceNetworkBehavior
import DeviceNetworkBehavior from 'src/views/Pages/Dashboard/DeviceNetworkBehavior/DeviceNetworkBehavior.vue'

let homePage = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: guards.guest,
  redirect: '/home',
  children: [
    {
      path: 'home',
      name: 'Tablero',
      component: Home
    },
    {
      path: 'profile',
      name: 'Usuario',
      component: User
    },
    {
      path: 'modules',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Modulos',
          component: Modules
        },
        {
          path: 'create',
          name: 'Crear Modulo',
          component: ModuleCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Modulo',
          component: ModuleCreateEdit,
        }
      ]
    },
    {
      path: 'companies',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Empresa',
          component: Companies
        },
        {
          path: 'create',
          name: 'Crear Empresa',
          component: CompaniesCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Empresa',
          component: CompaniesCreateEdit,
        }
      ]
    },
    {
      path: 'departments',
      name: 'Departamentos',
      component: Departments,
    },
    {
      path: 'roles',
      name: 'Perfiles',
      component: Roles,
    },
    {
      path: 'permissions',
      name: 'Permisos',
      component: Permissions,
    },
    {
      path: 'users',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Usuarios',
          component: Users
        },
        {
          path: 'create',
          name: 'Crear Usuario',
          component: UserCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Usuario',
          component: UserCreateEdit,
        }
      ]
    },
    {
      path: 'monitorings',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Informe de Seguimientos',
          component: Monitorings
        },
        {
          path: 'create',
          name: 'Crear Informe de Seguimiento',
          component: MonitoringsCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Informe de Seguimiento',
          component: MonitoringsCreateEdit,
        }
      ]
    },
    {
      path: 'demands',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Demandas',
          component: Demands
        },
        {
          path: 'create',
          name: 'Crear Demanda',
          component: DemandsCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Demanda',
          component: DemandsCreateEdit,
        }
      ]
    },
    {
      path: 'planningdocuments',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Documentos de Planeación',
          component: Plannings
        },
        {
          path: 'create',
          name: 'Crear Documento de Planeación',
          component: PlanningCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Documento de Planeación',
          component: PlanningCreateEdit,
        }
      ]
    },
    {
      path: 'instalations',
      name: 'Instalaciones',
      component: Instalations,
    },
    {
      path: 'subscriptions',
      name: 'Suscripciones',
      component: Subscriptions,
    },
    {
      path: 'inventories',
      name: 'Inventarios',
      component: Inventories,
    },
    {
      path: 'operationsusers',
      name: 'Operaciones de Usuarios',
      component: OperationsUsers,
    },
    {
      path: 'billingsupports',
      name: 'Soportes de Facturación',
      component: BillingSupports,
    },
    {
      path: 'pqr',
      name: 'PQR & Mantenimiento',
      component: PqrsMaintenance,
    },
    {
      path: 'preventiveMaintenance',
      name: 'Mantenimientos Preventivos',
      component: PreventiveMaintenance,
    },
    {
      path: 'indicators',
      name: 'Indicadores',
      beforeEnter: guards.change,
      component: Indicators,
    },
    {
      path: 'changesreplacements',
      name: 'Cambios & Reemplazos',
      component: ChangesReplacements,
    },
    {
      path: 'qualityusersupports',
      name: 'Calidad de Atención al Usuario',
      component: QualityUserSupports,
    },
    {
      path: 'telephoneattentionchannel',
      name: 'Canal de atención telefónica',
      component: TelephoneAttentionChannel,
    },
    {
      path: 'availability',
      name: 'Disponibilidad',
      component: Availability,
    },
    {
      path: 'navigationspeed',
      name: 'Velocidad de Navegación',
      component: NavigationSpeed,
    },
    {
      path: 'devicenetworkbehavior',
      name: 'Comp. de Red Dispositivos',
      component: DeviceNetworkBehavior,
    },
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  beforeEnter: guards.auth,
  component: Login
}

let loginGoogle =  {
  path: '/auth/:provider/callback',
  component: {
    template: '<div class="auth-component"></div>'
  }
}

let passwordResetPage = {
  path: '/password_reset/:token',
  name: 'PasswordReset',
  beforeEnter: guards.auth,
  component: PasswordReset
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  beforeEnter: guards.inactive,
  component: Lock
}

let notFoundPage = {
  path: '*',
  name: 'NotFound',
  component: NotFound
}

const routes = [
  homePage,
  loginPage,
  loginGoogle,
  passwordResetPage,
  lockPage,
  notFoundPage
]

export default routes
